import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../spinner/spinner.component';
import { SpinnerComponentModel } from '../../../models/spinner-component.model';
import { SpinnerPageService } from '../../../services/spinner-page.service';

@Component({
  selector: 'app-spinner-page',
  templateUrl: './spinner-page.component.html',
  styleUrls:['./spinner-page.component.scss'],
  standalone:true,
  imports:[
    CommonModule,
    SpinnerComponent
  ]
})
export class SpinnerPageComponent extends SpinnerComponentModel{
  constructor(spinnerPageService:SpinnerPageService){
    super(spinnerPageService);
  }
}
